import { createAsyncThunk } from "@reduxjs/toolkit";
import { getDataAPI, postDataAPI, putDataAPI } from "../../utils/FetchData";
import { setErrorAlert, setLoader, setSuccessAlert } from "../alert/alertSlice";
import { get_todo_thunk } from "../todo/todoThunk";
import { sync_data_thunk } from "../auth/authThunk";

export const create_folder_thunk = createAsyncThunk('user/folder/create_folder_or_file', async (tempData, thunkAPI) => {
    try {

        let body = {
            id: tempData?.data?.id,
            name: tempData?.data?.name,
            parentId: tempData?.data?.parentId,
            type: tempData?.data?.type,
            folderOrder: tempData?.data?.folderOrder
        }
        await postDataAPI('user/folder/create_folder_or_file', body, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})
export const get_folder_thunk = createAsyncThunk('user/folder/get_folder_or_file', async (tempData, thunkAPI) => {
    try {

        const response = await getDataAPI('user/folder/get_folder_or_file', tempData.token);
        localStorage.setItem(`folder`, JSON.stringify(response.data.data.response));
        return response.data
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'Your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})


export const delete_folder_thunk = createAsyncThunk('user/folder/delete_folder_or_file', async (tempData, thunkAPI) => {
    try {
        await getDataAPI(`user/folder/delete_folder_or_file/${tempData?.id}`, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})

export const update_folder_thunk = createAsyncThunk('user/folder/update_folder_or_file', async (tempData, thunkAPI) => {
    try {
        await putDataAPI('user/folder/update_folder_or_file', tempData.data, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})


export const update_file_color_thunk = createAsyncThunk('user/folder/update_file_color', async (tempData, thunkAPI) => {
    try {
        await putDataAPI('user/folder/update_file_color', tempData.data, tempData.token);
        return
    } catch (error) {
        console.log('error', error)
        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})

export const update_shortcut_thunk = createAsyncThunk('user/folder/update_shortcut_key', async (tempData, thunkAPI) => {
    try {
        await putDataAPI('user/folder/update_shortcut_key', tempData.data, tempData.token);
        return
    } catch (error) {
        console.log('error', error)

        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})

export const move_file_thunk = createAsyncThunk(
    'user/folder/move_todo',
    async (tempData, thunkAPI) => {
      try {
        await putDataAPI('user/folder/move_file', tempData.data, tempData.token);
        return;
      } catch (error) {
        console.log('error', error);
        thunkAPI.dispatch(
          sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'Failed to move todo'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'Failed to move todo');
      }
    }
  );



export const create_or_update_folder_order = createAsyncThunk('user/order/create_or_update_folder_order', async (tempData, thunkAPI) => {
    try {
        await putDataAPI('user/order/create_or_update_folder_order', tempData.data, tempData.token);
        return
    } catch (error) {
        console.log('error', error)

        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})
export const get_folder_order = createAsyncThunk(
    'user/order/get_folder_order',
    async (tempData, thunkAPI) => {
        try {
            const response = await getDataAPI('user/order/get_folder_order', tempData.token);
            const folderOrder = response.data?.data?.response?.folderOrder || [];
            
            // Store in localStorage
            try {
                localStorage.setItem('folderOrderIds', JSON.stringify(folderOrder));
            } catch (error) {
                console.error('Failed to save folder order to localStorage:', error);
            }

            return { data: { response: { folderOrder } } };
        } catch (error) {
            console.error('Error fetching folder orders:', error);
            const errorMessage = error?.response?.data?.message || 
                'The data is not stored because your network is offline';
            thunkAPI.dispatch(setErrorAlert(errorMessage));
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

export const create_or_update_file_order = createAsyncThunk('user/order/create_or_update_file_order', async (tempData, thunkAPI) => {
    try {
        await putDataAPI('user/order/create_or_update_file_order', tempData.data, tempData.token);
        return
    } catch (error) {
        console.log('error', error)

        thunkAPI.dispatch(
            sync_data_thunk({ token: tempData.token })
        );
        thunkAPI.dispatch(setErrorAlert(error?.response?.data?.message || 'The data is not stored because your network is offline'));
        return thunkAPI.rejectWithValue(error?.response?.data?.message || 'The data is not stored because your network is offline');
    }
})

export const get_file_order = createAsyncThunk(
    'user/order/get_file_order',
    async (tempData, thunkAPI) => {
        try {
            const response = await getDataAPI('user/order/get_file_order', tempData.token);
            
            // Extract the array of file orders from the response
            const fileOrdersArray = response.data?.data?.response || [];
            
            // Transform array of file orders into an object with folderId as keys
            const fileOrders = fileOrdersArray.reduce((acc, item) => {
                if (item?.folderId && Array.isArray(item?.fileOrder)) {
                    acc[item.folderId] = item.fileOrder;
                }
                return acc;
            }, {});

            // Store in localStorage
            try {
                localStorage.setItem('fileOrderIds', JSON.stringify(fileOrders));
            } catch (error) {
                console.error('Failed to save file order to localStorage:', error);
            }

            return fileOrders;
        } catch (error) {
            console.error('Error fetching file orders:', error);
            const errorMessage = error?.response?.data?.message || 
                'The data is not stored because your network is offline';
            thunkAPI.dispatch(setErrorAlert(errorMessage));
            return thunkAPI.rejectWithValue(errorMessage);
        }
    }
);

